import { connect } from 'react-redux';
import {
    selectRestaurantInfoVisibility,
    selectIsRestaurantLoaded,
    selectRestaurantBackground,
    selectRestaurantBackgroundSrcSet,
    selectRestaurantLogo,
    selectRestaurantLogoSrcSet,
    selectRestaurantDescription,
    selectRestaurantName,
    showInfo,
    hideInfo,
    readInfo,
    selectIsInfoRead,
    selectCode
} from 'src/modules/Restaurant';
import { selectMultipleMenus } from 'src/modules/Menu';
import {
    selectIsOrderContextDefined,
    selectOrderContext,
    selectIsReadOnlyMenu
} from 'src/modules/Order';

import { emitMessage, clearMessages } from 'src/modules/Modal';

const mapDispatchToProps = {
    showInfo,
    hideInfo,
    emitMessage,
    clearMessages,
    readInfo
};

const mapStateToProps = (state) => ({
    isInfoVisible: selectRestaurantInfoVisibility(state),
    isOrderContextDefined: selectIsOrderContextDefined(state),
    isLoaded: selectIsRestaurantLoaded(state),
    backgroundUrl: selectRestaurantBackground(state),
    backgroundSrcSetUrls: selectRestaurantBackgroundSrcSet(state),
    logoUrl: selectRestaurantLogo(state),
    logoSrcSetUrls: selectRestaurantLogoSrcSet(state),
    multipleMenus: selectMultipleMenus(state),
    context: selectOrderContext(state),
    isInfoRead: selectIsInfoRead(state),
    code: selectCode(state),
    isReadOnlyMenu: selectIsReadOnlyMenu(state),
    description: selectRestaurantDescription(state),
    name: selectRestaurantName(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
